
export const websiteForm = [
  {
    name: "name",
    label: "Website Name",
    type: "text",
    placeholder: "Enter name",
  },
  {
    name: "url",
    label: "URL",
    type: "text",
    placeholder: "Enter URL",
  },
  {
    name: "isSourceSite",
    label: "Is Source Site?",
    type: "checkbox",
  },
  {
    name: "isCustomLogin",
    label: "Custom login Enabled?",
    type: "checkbox",
  }, 
  {
    name: "customLoginPath",
    label: "Login Url",
    type: "text",
    placeholder: "Enter Login Url",
    visibilityDependant: "isCustomLogin",
  }, 
   {
    name: "username",
    label: "Username",
    type: "text",
    placeholder: "Enter Username",
    visibilityDependant: "isCustomLogin",
  }, 

   {
    name: "email",
    label: "Email",
    type: "email",
    placeholder: "Enter Email",
    visibilityDependant: "isCustomLogin",
  }, 

   {
    name: "password",
    label: "Password",
    type: "password",
    placeholder: "Enter Password",
    visibilityDependant: "isCustomLogin",
  }, 
   
];